<template>
    <div class="container mt-4">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="card">
                    <div class="card-header">
                        {{ $t('auth.login_header') }}
                    </div>

                    <div class="card-body">
                        <validation-errors :errors="errors" v-if="errors" />

                        <form @submit.prevent="handleLogin">
                            <div class="form-group row">
                                <label for="email" class="col-md-4 col-form-label text-md-right">{{ $t('auth.email') }}</label>

                                <div class="col-md-6">
                                    <input id="email" type="email" class="form-control" name="email" required autocomplete="email" autofocus ref="email" v-model="email">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="password" class="col-md-4 col-form-label text-md-right">{{ $t('auth.password') }}</label>

                                <div class="col-md-6">
                                    <input id="password" type="password" class="form-control" name="password" required autocomplete="current-password" v-model="password">
                                </div>
                            </div>

                            <div class="form-group row" v-if="false">
                                <div class="col-md-6 offset-md-4">
                                    <div class="form-check">
                                        <input id="remember" class="form-check-input" type="checkbox" name="remember" v-model="remember_me">

                                        <label class="form-check-label" for="remember">
                                            {{ $t('auth.remember_me') }}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row mb-0">
                                <div class="col-md-8 offset-md-4">
                                    <button type="submit" class="btn btn-primary" :disabled="loading">
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                        {{ $t('auth.submit') }}
                                    </button>

                                    <router-link :to="{name: 'password-reset.index'}" class="btn btn-link">
                                        {{ $t('auth.forgot_password') }}
                                    </router-link>
                                </div>
                            </div>
                        </form>

                        <div class="alert alert-warning mt-3" v-if="accountNotActivated">
                            {{ $t('auth.activate_account_here') }} <router-link :to="{name: 'register.confirm'}">{{ $t('auth.activate_account_here_link') }}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ValidationErrors from '@components/ValidationErrors';
    import backofficeRepository from '@repositories/BackofficeRepository';
    import toastr from 'toastr';

    export default {
        components: {
            ValidationErrors,
        },

        data() {
            return {
                email: '',
                password: '',
                remember_me: false,
                errors: [],
                redirectTo: this.$route.query.redirectTo,
                accountNotActivated: false,
                loading: false,
            };
        },

        mounted() {
            this.$nextTick(() => {
                this.$refs.email.focus();
            });
        },

        methods: {
            async handleLogin() {
                this.errors = [];
                this.accountNotActivated = false;
                this.loading = true;
                try {
                    const response = await backofficeRepository.login({
                        username: this.email,
                        password: this.password,
                    });
                    if (response.status === true) {
                        const userData = await backofficeRepository.getCurrentUser();
                        let user = userData.data.me;
                        //add all internal properties of userData.data.me.clientProfile.client to user
                        Object.assign(user, userData.data.me.clientProfile.client);
                        await this.$store.dispatch('user/setUser', user);
                        toastr.success(this.$t('auth.login_success'));
                        if(this.redirectTo){
                            this.$router.push(this.redirectTo);
                        }
                        else{
                            this.$router.push({ name: 'home.index' });
                        }
                    } else {
                        this.errors = [response.error];
                    }
                } catch (error) {
                    console.error(error);
                    if(error.toString().match('iam.user.login_is_invited')){
                        this.accountNotActivated = true;
                        this.errors = [this.$t('validation.iam.user.login_is_invited')];
                    }
                    else{
                        this.errors = [this.$t('auth.login_failed')];
                    }
                } finally {
                    this.loading = false;
                }
            },
        },
    };
</script>
